import React from "react";

import styles from './Overlay.module.scss';

const Overlay = ({
        className = '',
        isContained = false,
        onClick = null,
        isActive = false
    }) => {

    const containedClass = isContained ? styles.contained : '';
    const activeClass = isActive ? styles.active : '';
    const blurClasses = `${styles.blur} ${containedClass} ${activeClass} ${className}`;

    return (
        <div className={ blurClasses } onClick={ onClick }>
            <div className={ styles.container } />
        </div>
    );
};

export default Overlay;
